export interface ListData {
  id: number;
  name: string;
  description: string;
}

export const initialListData: ListData = {
  id: 0,
  name: "",
  description: "",
};
